
import React from "react";
import { 
  Tooltip, 
  TooltipContent, 
  TooltipProvider, 
  TooltipTrigger 
} from "@/components/ui/tooltip";

interface FileItemTooltipProps {
  isLocked: boolean;
  children: React.ReactNode;
}

export function FileItemTooltip({ isLocked, children }: FileItemTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          {children}
        </TooltipTrigger>
        {isLocked && (
          <TooltipContent className="bg-[#1A1F2C] text-white">
            <p>Complete previous content first</p>
          </TooltipContent>
        )}
      </Tooltip>
    </TooltipProvider>
  );
}
